<template>
  <div class="alojamento_icons">
    <div class="row">
      <div class="small-12 medium-12 large-12 columns">
        <SliderItem 
          @click="currentSection = item"
          :title="item.title"
          :image="item.image"
          :isActive="currentSection.title == item.title"
          :key="item.title"
          v-for="item in sections"/>
      </div>
    </div>
    <div class="areacontent" :style="{ height : currentsize +'px'}">
      <div class="row texto_areas_al"  
        :class="{'active': currentSection.title == item.title}"
        :key="item.title"
        :ref="el => setRef(el, item.title)"
        v-for="item in sections">
          <p v-html="currentSection.content"></p>
      </div>
    </div>
    <ResponsiveNavigation 
      @set-section="setSection"
      :currentSection="currentSection"
      :sections="sections"/>
  </div>
</template>

<script>
import { ref, reactive, watch, nextTick, computed } from "vue";
import { i18n } from "@/main.js";
import sas_cozinha from "@/assets/images/sas_cozinha.png";
import sas_lavandaria from "@/assets/images/sas_lavandaria.png";
import sas_estudo from "@/assets/images/sas_estudo.png";
import sas_convivio from "@/assets/images/sas_convivio.png";
import sas_parque from "@/assets/images/sas_parque.png";

import SliderItem from "@/components/areaslider/SliderItem.vue";
import ResponsiveNavigation from "@/components/areaslider/ResponsiveNavigation.vue";

export default {
  components:{
    SliderItem,
    ResponsiveNavigation
  },
  setup() {

    const { t } = i18n.global;   

    const sections = [
      { image: sas_cozinha, title: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA"), content: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_COZINHA_TEXTO") },
      { image: sas_lavandaria, title: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA"), content: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_LAVANDARIA_TEXTO") },
      { image: sas_estudo, title: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO"), content: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALAESTUDO_TEXTO") },
      { image: sas_convivio, title: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO"), content: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_SALACONVIVIO_TEXTO") },
      { image: sas_parque, title: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO"), content: t("UMA_LANG_SASUMA_ALOJAMENTO_AREACOMUM_ESTACIONAMENTO_TEXTO") },
    ];

    const currentSection = ref(sections[0]);

    const dynamicRefs = reactive({});
    const setRef = (el, name) => {
      if (el) {
        dynamicRefs[name] = el;
      }
    };

    const currentsize = ref(0);
    const currentContent = computed(() => dynamicRefs[currentSection.value.title]);

    watch(currentSection, () => {
      nextTick(() => {
        currentsize.value = currentContent.value?.clientHeight;
      })
    }, { immediate: true });

    const setSection = (section) => {
      currentSection.value = section;
    }

    return {
      setSection,
      setRef,
      currentsize,
      currentSection,
      sections
    }

  }
}
</script>

<style lang="scss" scoped>
.alojamento_icons{
  margin-bottom: 140px;
}

.alojamento_icons .row .columns {
  display: flex;
  justify-content: center;
  padding-left: 0;
  padding-right: 0;
}

.areacontent{
  position: relative;
  min-height: 0;
  transition: height 500ms ease-in-out;
}

.texto_areas_al {
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  margin-bottom: 2px;
  text-align: center;
  padding: 50px;
  opacity: 0;
  transition: opacity 500ms ease-in-out;
  z-index: -1;
}

.texto_areas_al.active{
  opacity: 1;
  z-index: 1;
}

.texto_areas_al p {
  font-family: "Montserrat Light";
  line-height: 2.3;
  color: #494d52eb;
}
</style>